import Text from '@cartwhl/ui/base/Text';

import LogoCarousel, { type LogoItem } from './LogoCarousel';
import {
  AutodeskLogo,
  BlenderLogo,
  Cinema4DLogo,
  GodotLogo,
  UnityLogo,
  UnrealEngineLogo,
} from './logos';

const toolLogos: LogoItem[] = [
  {
    name: 'Unreal Engine',
    icon: <UnrealEngineLogo />,
    width: 'w-[131px] lg:w-[196px]',
  },
  { name: 'Blender', icon: <BlenderLogo />, width: 'w-[77px] lg:w-[116px]' },
  { name: 'Unity', icon: <UnityLogo />, width: 'w-[60px] lg:w-[90px]' },
  { name: 'Autodesk', icon: <AutodeskLogo />, width: 'w-[79px] lg:w-[118px]' },
  { name: 'Cinema 4D', icon: <Cinema4DLogo />, width: 'w-[80px] lg:w-[120px]' },
  { name: 'Godot', icon: <GodotLogo />, width: 'w-[61px] lg:w-[92px]' },
];

export default function IntroSection() {
  return (
    <section className="py-(--vertical-spacing)">
      <div className="container mb-12 lg:mb-20">
        <Text
          as="p"
          lg:variant="web/body/medium/xl"
          variant="web/body/medium/lg"
          className="max-w-[920px]"
        >
          Create, capture, and reshape motion—faster and with more precision
          using state-of-the-art AI. Work directly in Cartwheel Canvas, or
          integrate via API for scalable, automated pipelines.
        </Text>
      </div>
      <LogoCarousel
        label="Works with the tools you already use:"
        logos={toolLogos}
        listClassName="lg:gap-22"
      />
    </section>
  );
}
